<script>
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsLayout from 'viralstyle-ui/src/VsLayout';
import { mapState } from 'vuex';

import pingpongSVG from '@/assets/images/pingpong.svg';
import SettingsPaymentPingpongAccounts from './SettingsPaymentPingpongAccounts';

export default {
  components: {
    VsButton,
    VsLayout,
    SettingsPaymentPingpongAccounts,
  },
  mixins: [vueMixins],
  props: {
    selectable: [Boolean, String],
    modal: [Boolean, String],
  },
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
    }),
    payoneerConnectImage() {
      return {
        backgroundImage: `url('data:image/png;base64,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')`,
      };
    },
    pingpongImage() {
      return {
        backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(pingpongSVG)}')`,
      };
    },
  },
  updated() {
    this.$emit('update');
  },
  methods: {
    register() {
      this.$store.dispatch('registerPingpong');
    },
  },
};
</script>

<template lang='pug'>
.accordion-content__client
  settings-payment-pingpong-accounts(v-if='get(paymentInfo, "pingpong_accounts.length")', :selectable='selectable')

  vs-layout.pingpong(v-else, wrap-xs, vert-align-center-xs)
    vs-layout(
      horz-align-center-xs,
      margin-top='2',
    )
      vs-button.pingpong--smaller-text(
        large,
        text='Connect PingPong Account',
        :processing='processing',
        :disabled='processing',
        single-line-button,
        @click='register',
      )
    vs-layout(margin-top='2')
      hr.pingpong__hr
    vs-layout(
      horz-align-center-xs,
      sm='4',
      lg='3',
      margin-top='2',
    )
      .pingpong__img(:style='pingpongImage')
    vs-layout(
      col-xs,
      vert-align-top-xs,
      sm='8',
      lg='9',
      margin-top='2',
    )
      h6.pingpong__text More than 43,000 e-commerce merchants around the world trust PingPong to save them money on cross-border payments,&nbsp;
        | VAT payments, supplier payments, and more. To date, PingPong has processed more than $10 billion for global e-commerce sellers.

      h6.pingpong__register
        a(href='https://pipopmt.com/Viralstyle', target='_blank') Register here for a PingPong Account!

  vs-button(
    v-if='!modal && get(paymentInfo, "pingpong_accounts.length")',
    large,
    text='Connect Another PingPong Account',
    :processing='processing',
    :disabled='processing',
    @click='register',
  )
</template>

<style>
@import '~import/index';
@import '~styles/index';

.pingpong {
  padding: 0 1.5rem 2rem;
  background-color: $white;

  &__img {
    height: 22px;
    width: 113px;
  }

  &__hr {
    width: 100%;
    border: none;
    border-top: 1px solid $textAccentColor;
  }

  &__text {
    color: $textAccentColor;
    text-align: left;
  }

  &__register {
    margin-top: 1rem;

    >a {
      color: $pingpongColor;
      text-decoration: underline;

      &:visited {
        color: darken($pingpongColor, 10%);
      }

      &:hover,
      &:active,
      &:visited {
        color: darken($pingpongColor, 7%);
      }
    }
  }

  &--smaller-text {
    @include mq(md) {
      font-size: 1rem;
    }

    @include mq(sm) {
      font-size: 1.4rem;
    }
  }
}
</style>
